// extracted by mini-css-extract-plugin
var _1 = "NavigationFooter_backButton__Wqw6I";
var _2 = "768px";
var _3 = "NavigationFooter_navigationFooterContainer__lQ4mi";
var _4 = "NavigationFooter_nextButton__5maJ8";
var _5 = "'../../shared.module.css'";
export { _1 as "backButton", _2 as "md", _3 as "navigationFooterContainer", _4 as "nextButton", _5 as "shared" }
